import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const myPayrollManifest: FeatureManifest = {
  id: 'my-payroll',
  path: 'my-payroll/:payrollId?',
  navPath: '/my-payroll',
  label: 'Lịch sử lương',
  requiredPermissions: [],
  navigationGroup: { id: 'employee-self', label: 'Thông tin cá nhân' },
  load: () => import('./entry'),
}
